import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import { ReactComponent as SearchIcon } from "../../../src/assets/Search.svg";
import { ReactComponent as CancelIcon } from "../../../src/assets/Cancel.svg";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
// import { useContext } from 'react';
import { ThemeContext } from "../../theme/ThemeContext";
const useStyles = makeStyles((theme) => ({
  container: {
    border: (props) =>
      props.darkMode
        ? "1px solid rgba(130, 130, 130, 0.5)"
        : "1px solid rgba(130, 130, 130, 0)",
    maxWidth: "250px",
    display: "flex",
    borderRadius: "10px 10px 10px 10px",
    backgroundColor: (props) => (props.darkMode ? "#0F273B" : "white"),
    "&:hover": {
      border: (props) =>
        props.darkMode
          ? "1px solid rgba(130, 130, 130, 1)"
          : "1px solid rgba(0, 0, 0, 0.4)",
    },
  },
  search_icon: (props) => ({
    boxSizing: "content-box ",
    backgroundColor: props.darkMode
      ? "#0B2E4D"
      : process.env.REACT_APP_BG_SEARCHBAR,
    padding: "12px",
    borderRadius: "0px 8px 8px 0px",
    cursor: "pointer",

    "&:hover": {
      background: props.darkMode
        ? "#0B2E4D"
        : process.env.REACT_APP_BG_SEARCHBAR,
      opacity: "1",
    },
  }),
}));

export default function Search(props) {
  const [inputValue, setInputValue] = React.useState("");
  const [focused, setFocused] = React.useState(false);
  const { t } = useTranslation();
  const { darkMode } = useContext(ThemeContext);
  const classes = useStyles({ darkMode });
  const handleTextChange = () => {
    props.onSearch(inputValue);
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setInputValue(value);
  };

  return (
    <Grid
      className={classes.container}
      style={{
        borderColor: focused ? " rgb(25, 118, 210)" : "",
        borderRadius: "10px 10px 10px 10px",
      }}
    >
      <InputBase
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={{
          backgroundColor: darkMode ? "#0F273B" : "white",
          color: darkMode ? "white" : "#0F273B",
          padding: "6px 0 7px 9px",
          borderRadius: "10px 10px 10px 10px",
        }}
        placeholder={t("SEARCH02")}
        onChange={handleChange}
        inputProps={{ "aria-label": "search" }}
        value={inputValue}
      />
      {inputValue.length ? (
        <CancelIcon
          style={{
            cursor: "pointer",
            backgroundColor: "rgb(129, 142, 152)",
            marginTop: "12px",
          }}
          onClick={() => {
            setInputValue("");
            props.clearSearch();
            props.onSearch("");
            props.loadData();
          }}
        />
      ) : (
        <></>
      )}
      <SearchIcon onClick={handleTextChange} className={classes.search_icon} />
    </Grid>
  );
}
